"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.service = void 0;
var descriptors_1 = require("../instantiation/descriptors");
var instantiation_factory_1 = require("../instantiation/instantiation-factory");
var error_messages_1 = require("../constants/error-messages");
/**
 * 类装饰器，用于将类放入DI容器
 * @param instantiationIdentifier
 */
function service(instantiationIdentifier) {
    return function (target) {
        if (instantiationIdentifier === undefined) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.SERVICE_DECORATOR_PARAMETER_ERROR(target.name));
        }
        // 将service放入容器
        var instantiationService = instantiation_factory_1.InstantiationFactory.getInstantiation(instantiationIdentifier);
        instantiationService.addService(target, new descriptors_1.SyncDescriptor(target));
    };
}
exports.service = service;
//# sourceMappingURL=service-decorator.js.map